package pl.mothdigital.neuronowi.components.sections.sidemenu

import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.css.functions.*
import com.varabyte.kobweb.compose.foundation.layout.*
import com.varabyte.kobweb.compose.ui.*
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.core.*
import com.varabyte.kobweb.silk.components.overlay.*
import com.varabyte.kobweb.silk.style.animation.*
import org.jetbrains.compose.web.css.*
import pl.mothdigital.neuronowi.components.sections.navheader.*
import pl.mothdigital.neuronowi.components.widgets.*
import pl.mothdigital.neuronowi.theme.*

@Composable
fun SideMenu(
    context: PageContext,
    menuState: SideMenuState,
    close: () -> Unit,
    onAnimationEnd: () -> Unit,
) {
    Overlay(
        Modifier
            .setVariable(OverlayVars.BackgroundColor, SiteTheme.black._900.toRgb().copy(alpha = 20))
            .onClick { close() }
            .zIndex(1000 + 2)

    ) {
        key(menuState) { // Force recompute animation parameters when close button is clicked
            Column(
                Modifier
                    .fillMaxHeight()
                    .width(clamp(8.cssRem, 70.percent, 16.cssRem))
                    .align(Alignment.CenterEnd)
                    // Close button will appear roughly over the hamburger button, so the user can close
                    // things without moving their finger / cursor much.
                    .padding(top = 1.cssRem, leftRight = 1.cssRem)
                    .gap(1.5.cssRem)
                    .backgroundColor(SiteTheme.white._900)
                    .animation(
                        SideMenuSlideInAnim.toAnimation(
                            duration = 200.ms,
                            timingFunction = if (menuState == SideMenuState.OPEN) AnimationTimingFunction.EaseOut else AnimationTimingFunction.EaseIn,
                            direction = if (menuState == SideMenuState.OPEN) AnimationDirection.Normal else AnimationDirection.Reverse,
                            fillMode = AnimationFillMode.Forwards
                        )
                    )
                    .borderRadius(topLeft = 2.cssRem)
                    .onClick { it.stopPropagation() }
                    .onAnimationEnd { onAnimationEnd() },
                horizontalAlignment = Alignment.End
            ) {
                CloseButton(onClick = { close() })
                Column(
                    Modifier.padding(right = 0.75.cssRem).gap(1.5.cssRem).fontSize(1.4.cssRem),
                    horizontalAlignment = Alignment.End
                ) {
                    MenuItems(context = context)
                }
                Spacer()
                Row {
                    FacebookButton()
                    InstagramButton()
                }
                VerticalSpacer(1.cssRem)
            }
        }
    }
}
